import React, { useEffect, useState } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { Auth } from 'aws-amplify';
import LoadingSpinner from './LoadingSpinner';
import { withTimeout, getCachedAuthUser } from '../../services/network';

const AUTH_TIMEOUT_MS = 4000;

export default function PublicRoute() {
  const [authState, setAuthState] = useState('loading');

  useEffect(() => {
    let cancelled = false;

    withTimeout(Auth.currentAuthenticatedUser(), AUTH_TIMEOUT_MS, 'Auth check timed out')
      .then(() => {
        if (!cancelled) setAuthState('authenticated');
      })
      .catch((err) => {
        if (cancelled) return;
        if (err?.isTimeoutError && getCachedAuthUser()) {
          setAuthState('authenticated');
          return;
        }
        setAuthState('unauthenticated');
      });

    return () => {
      cancelled = true;
    };
  }, []);

  if (authState === 'loading') {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner />
      </div>
    );
  }

  if (authState === 'authenticated') {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
